// extracted by mini-css-extract-plugin
export default {"externalSystemDescription":"style--externalSystemDescription--2f94f9","header":"style--header--ff654b","description":"style--description--f23ec4"};